<h1 mat-dialog-title
    class="draggable-dialogue-header"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle>
    Copy Site
</h1>

<form>
    <div mat-dialog-content>
        <mat-form-field appearance="outline"
                        class="site-copy-name-mat-form-field">
            <mat-label>Site Copy Name</mat-label>
            <input matInput
                   [(ngModel)]="this.SiteCopyName"
                   placeholder="Name for Copied Site"
                   [disabled]="this.JobInitiated"
                   name="siteCopyName"
                   autocomplete="off"
                   required />
        </mat-form-field>
    </div>

    <div class="execution-time-div">
        <span>Execution Time:</span>
        <span [ngClass]="this.JobInProgress ? 'active-execution-time-span' : 'idle-execution-time-span'">{{this.JobTimeElapsed}}</span>
    </div>

    <div class="execution-status-div">
        <span>Execution Status:</span>
        <span [ngClass]="this.JobCompleted ? 'completed-execution-status-span' : 'incomplete-execution-status-span'">{{this.CopyStatus}}</span>
    </div>

    <div mat-dialog-actions>
        <button mat-flat-button
                type="submit"
                color="primary"
                class="theme-primary-btn"
                [disabled]="(!this.SiteCopyName) || (this.SiteCopyName.trim().length == 0) || this.JobInitiated"
                (click)="this.startSiteCopy()">
            Start Copy ...
        </button>
        <button mat-flat-button
                type="submit"
                color="accent"
                [disabled]="!this.JobInitiated"
                [mat-dialog-close]="this.CompletedSiteCopyId">
            {{this.DismissButtonTitle}}
        </button>
        <button mat-flat-button
                [disabled]="this.JobInitiated"
                [mat-dialog-close]="null"
                style="margin-left: 10px;">
            Cancel
        </button>
    </div>
</form>
